import { createContext } from "react";

export type Item = {
    example_prop: number;
};

interface ContextProps {
    coordinates: number[];
    setCoordinates: Function;
}

export const CoordinatesContext = createContext<ContextProps>({
    coordinates: [],
    setCoordinates: () => null
});
